<ng-container *ngIf="faDirective === FaDirectiveEnum.FAS">
  <mdb-icon [size]="size" fas [icon]="icon" [title]="title" [class]="class"></mdb-icon>
</ng-container>
<ng-container *ngIf="faDirective === FaDirectiveEnum.FAR">
  <mdb-icon [size]="size" far [icon]="icon" [title]="title" [class]="class"></mdb-icon>
</ng-container>
<ng-container *ngIf="faDirective === FaDirectiveEnum.FAB">
  <mdb-icon [size]="size" fab [icon]="icon" [title]="title" [class]="class"></mdb-icon>
</ng-container>
